import { buildQueries, queryAllByText } from '@testing-library/react'

import { useTestFormatPrice } from '@webapp/tests/intlFormatHookMocks/useTestFormatPrice'

export const queryAllPriceByText = (
  container: HTMLElement,
  price: string | number,
  currencyName
) => {
  return queryAllByText(
    container,
    `${useTestFormatPrice(price)} ${currencyName}`
  )
}

const getPriceMultipleError = (
  c,
  price: string | number,
  currencyName: string
) => `Found prices with text: ${useTestFormatPrice(price)} ${currencyName}`

const getPriceMissingError = (
  c,
  price: string | number,
  currencyName: string
) => {
  return `Unable to find a price with text: ${useTestFormatPrice(
    price
  )} ${currencyName}`
}

const [
  queryPriceByText,
  getAllPriceByText,
  getPriceByText,
  findAllPriceByText,
  findPriceByText,
] = buildQueries(
  queryAllPriceByText,
  getPriceMultipleError,
  getPriceMissingError
)

export {
  queryPriceByText,
  getAllPriceByText,
  getPriceByText,
  findAllPriceByText,
  findPriceByText,
}
